var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFanCooler(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.9205 79.9942C29.0007 79.9942 18.0783 80.0023 7.15849 79.9889C3.54712 79.9862 0.985163 78.07 0.235582 74.8191C0.0642497 74.0794 0.0187395 73.2941 0.0187395 72.5303C0.00267707 51.4035 0 30.2741 0 9.14466C0 8.17717 0.0401561 7.207 0.0963746 6.2395C0.278416 3.02077 2.71455 0.442572 5.91097 0.0861265C6.43836 0.0271656 6.97645 0.00304525 7.50919 0.00304525C29.0837 0.000365212 50.6556 -0.00767491 72.2301 0.0218055C73.3786 0.0218055 74.5886 0.158488 75.6621 0.536373C78.1464 1.41275 79.5037 3.31826 79.8865 5.9045C79.9856 6.56111 79.9963 7.23647 79.9963 7.90381C80.0016 29.3683 80.0016 50.8327 79.9936 72.2945C79.9936 73.1253 79.9668 73.9775 79.7848 74.7842C79.0968 77.8609 76.5669 79.9219 73.3812 79.9701C69.8421 80.0237 66.3004 79.9889 62.7613 79.9889C55.1477 79.9889 47.5341 79.9889 39.9178 79.9889L39.9205 79.9942ZM39.9473 76.7112C60.6223 76.7112 76.5107 60.3066 76.6151 40.3591C76.7222 19.9023 60.368 3.43618 40.1721 3.43886C19.7354 3.44154 3.34099 19.6772 3.37311 39.874C3.40524 60.2772 19.7488 76.738 39.9446 76.7112H39.9473ZM72.479 11.1976C74.5672 11.2137 76.2564 9.56007 76.2644 7.49376C76.2725 5.45425 74.5538 3.73634 72.5085 3.73902C70.4284 3.73902 68.8141 5.39529 68.8141 7.52056C68.8141 9.59491 70.3936 11.1788 72.479 11.1949V11.1976ZM68.8115 72.5705C68.8034 74.6717 70.4498 76.336 72.5246 76.3279C74.5136 76.3199 76.243 74.6181 76.2618 72.6509C76.2805 70.539 74.5886 68.856 72.455 68.8667C70.4097 68.8774 68.8195 70.4935 68.8115 72.5678V72.5705ZM7.56541 68.8694C5.49603 68.8747 3.8068 70.5605 3.80144 72.6214C3.79877 74.6047 5.52548 76.3306 7.51454 76.3279C9.50093 76.3279 11.2517 74.6181 11.2839 72.6536C11.316 70.598 9.61337 68.8613 7.56541 68.8667V68.8694ZM7.39943 11.1976C9.49557 11.2378 11.1634 9.68335 11.2035 7.65724C11.2464 5.54001 9.66959 3.85694 7.58415 3.79262C5.55492 3.7283 3.78806 5.42745 3.75326 7.475C3.71845 9.49843 5.34611 11.1601 7.39943 11.1976Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.041 30.577C45.288 30.5931 49.4616 34.7632 49.4535 39.9839C49.4455 45.3333 45.2613 49.5061 39.9178 49.4927C34.6975 49.4793 30.5266 45.21 30.5588 39.9142C30.5909 34.6909 34.7832 30.5609 40.041 30.577Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6468 50.0073C48.0829 48.4984 49.8551 46.4375 50.7707 43.9022C52.9873 44.5668 55.0808 45.3467 57.2412 45.813C60.5875 46.534 63.9419 46.2204 67.2507 45.3949C67.6068 45.3065 67.9655 45.2047 68.3269 45.1859C69.6387 45.1243 70.5248 46.0837 70.2383 47.3621C69.3924 51.1463 67.9762 54.6947 65.5562 57.766C63.8937 59.8725 61.0105 60.7516 58.4137 59.6581C53.3969 57.5489 49.0466 54.4776 45.6494 50.0073H45.6468Z",
    fill: "url(#paint0_linear_2_1724)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3468 30.1589C31.8946 31.641 30.192 33.7234 29.2336 36.2587C27.1642 35.6316 25.1966 34.9026 23.1674 34.447C19.5828 33.6376 16.0035 33.9753 12.4644 34.8651C10.3977 35.385 9.36172 34.3371 9.87839 32.2681C10.7083 28.9342 12.0201 25.8092 13.9957 22.9871C15.8991 20.2696 18.9403 19.3369 21.9332 20.6743C26.5619 22.7459 30.623 25.6189 33.8944 29.5425C34.0416 29.7167 34.1675 29.9097 34.3495 30.1563L34.3468 30.1589Z",
    fill: "url(#paint1_linear_2_1724)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7271 30.175C43.1892 28.784 40.5684 28.3793 37.8029 28.8349C37.5647 27.4279 37.3934 26.104 37.1096 24.8068C36.3199 21.2102 34.6092 18.0746 32.2266 15.2927C31.7046 14.6843 31.1585 14.0974 30.6391 13.489C29.3514 11.9909 29.7289 10.6375 31.6162 10.1068C35.1446 9.11252 38.7372 8.58991 42.3888 9.13932C45.4219 9.59492 47.5823 12.007 47.85 15.0729C48.2837 20.023 47.8446 24.8712 46.0189 29.5371C45.9466 29.722 45.8556 29.8989 45.7298 30.175H45.7271Z",
    fill: "url(#paint2_linear_2_1724)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2307 47.6409C29.9645 48.7665 28.5456 49.8867 27.2901 51.1651C24.7201 53.7889 23.0389 56.954 21.9788 60.4622C21.8155 61.0035 21.687 61.5664 21.4434 62.0729C20.924 63.1503 19.7381 63.5496 18.86 62.767C15.7144 59.9556 13.0534 56.7208 11.8005 52.6284C11.0162 50.0663 11.9531 47.7052 14.0546 46.1132C18.3112 42.8838 23.0898 40.7505 28.3797 39.992C28.6955 41.3508 28.8829 42.7471 29.3621 44.0362C29.8306 45.2958 30.5963 46.4456 31.2281 47.6409H31.2307Z",
    fill: "url(#paint3_linear_2_1724)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34.221 49.8545C36.7615 51.2347 39.3717 51.7145 42.2308 51.216C42.3406 51.9369 42.4557 52.5828 42.5333 53.2314C43.1089 58.0528 45.2505 62.1211 48.4951 65.6614C48.878 66.0795 49.2849 66.4815 49.6276 66.9344C50.4574 68.0332 50.1576 69.3974 48.8646 69.786C45.0953 70.9116 41.2349 71.5253 37.3077 70.8875C34.5771 70.4453 32.4488 67.9662 32.173 65.187C31.651 59.9556 32.2078 54.8662 34.221 49.8545Z",
    fill: "url(#paint4_linear_2_1724)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6113 40.0321C51.2017 37.2529 50.3825 34.6962 48.6665 32.4074C49.2394 31.9357 49.7373 31.5096 50.2513 31.1022C54.2776 27.9291 56.8128 23.7857 58.1782 18.8839C58.8099 16.6139 60.1565 16.2387 61.8377 17.8896C64.1212 20.1328 65.9711 22.6976 67.4355 25.5385C69.2077 28.9797 68.2975 32.3994 65.077 34.5381C61.5218 36.8992 57.7418 38.7672 53.5495 39.6998C52.9659 39.8285 52.3689 39.9062 51.6113 40.0348V40.0321Z",
    fill: "url(#paint5_linear_2_1724)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_1724",
    x1: 24.065,
    y1: 14.2807,
    x2: 53.6417,
    y2: 68.9576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01F68D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C84DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_1724",
    x1: 24.065,
    y1: 14.2807,
    x2: 53.6417,
    y2: 68.9576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01F68D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C84DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2_1724",
    x1: 24.065,
    y1: 14.2807,
    x2: 53.6417,
    y2: 68.9576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01F68D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C84DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2_1724",
    x1: 24.065,
    y1: 14.2807,
    x2: 53.6417,
    y2: 68.9576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01F68D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C84DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2_1724",
    x1: 24.065,
    y1: 14.2807,
    x2: 53.6417,
    y2: 68.9576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01F68D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C84DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2_1724",
    x1: 24.065,
    y1: 14.2807,
    x2: 53.6417,
    y2: 68.9576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01F68D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C84DC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFanCooler);
export default __webpack_public_path__ + "static/media/fan-cooler.748830df7d69a1625544f7cb83c161b2.svg";
export { ForwardRef as ReactComponent };